<template>
	<div class="col px-4 py-0 d-flex align-items-center">
		<div class="px-0 py-5 w-100 h-100 d-flex align-items-center justify-content-center flex-column" v-if="top">
			<div class="bg-black px-2 py-1 border border-2 border-white rounded-3 my-3 text-dark shadow-inner fw-medium"><span class="text">{{year}}</span></div>
			<div class="p-2 rounded-circle border border-white border-2 position-relative"></div>
			<div class="conn bg-secondary py-5"></div>
			<div class="bg-white p-5 rounded-3 w-100 h-50 shadow position-relative">
                <div class="position-absolute start-0 top-0 w-100 h-100 p-2 d-flex flex-column align-items-center">
                    <span class="badge bg-success shadow" v-if="edu">Education</span>
                    <span class="badge bg-warning shadow" v-else>Experience</span>
                    <span class="flex-fill d-flex align-items-center justify-content-center fw-medium">
                        {{headline}}
                    </span>
                </div>
            </div>
		</div>
		<div class="bg-dange px-0 py-5 w-100 h-100 d-flex align-items-center justify-content-center flex-column" v-else>
			<div class="bg-black px-2 py-1 border border-2 border-white rounded-3 my-3 text-dark shadow-inner fw-medium"><span class="text">{{year}}</span></div>
			<div class="bg-white p-5 rounded-3 w-100 h-50 shadow position-relative">
                <div class="position-absolute start-0 top-0 w-100 h-100 p-2 d-flex flex-column align-items-center">
                    <span class="badge bg-success shadow" v-if="edu">Education</span>
                    <span class="badge bg-warning shadow" v-else>Experience</span>
                    <span class="flex-fill d-flex align-items-center justify-content-center fw-medium">
                        {{headline}}
                    </span>
                </div>
            </div>
			<div class="conn bg-secondary py-5"></div>
			<div class="p-2 rounded-circle border border-white border-2 position-relative"></div>
		</div>
	</div>
</template>
<style scoped>
.conn {
	padding-inline: 1px;
}
.year {
	filter: invert(70%);
}
.shadow-inner {
	box-shadow: inset 0 0 4px 1px rgba(0,0,0,0.4);
}
.text {
	filter: invert(100%);
	color: black;
}
</style>
<script>
export default {
	name: "XpCard",
	props: {
		top: Boolean,
		year: String,
        edu: Boolean,
        headline: String
	}
}
</script>